module.exports = __webpack_public_path__ + "static/media/PhillipBowden.ab72d188.jpg";